import { Controller } from "@hotwired/stimulus"

// Collapsible section in the admin sidebar navigation (Sidebar::NavigationComponent).
//
// The server renders the state — collapsed sections come from Account#sidebar_collapsed_sections,
// and the section holding the active page is always open — so this only flips the section and
// tells the server. The state follows the account across devices; it used to live in
// localStorage, per browser.
export default class extends Controller {
  static targets = ["content", "chevron", "button"]
  static values = { key: String, url: String }

  toggle() {
    const collapsed = !this.contentTarget.classList.contains("hidden")
    this.applyState(collapsed)
    this.persist(collapsed)
  }

  applyState(collapsed) {
    this.contentTarget.classList.toggle("hidden", collapsed)
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("-rotate-90", collapsed)
    if (this.hasButtonTarget) this.buttonTarget.setAttribute("aria-expanded", String(!collapsed))
  }

  // Fire and forget: a lost write costs the state on the next page, not the click now.
  persist(collapsed) {
    if (!this.hasUrlValue) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new FormData()
    body.append("collapsed", String(collapsed))

    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token ?? "", Accept: "application/json" },
      body,
      credentials: "same-origin",
    }).catch(() => {})
  }
}
